// extracted by mini-css-extract-plugin
export default {"divider":"MobileNavigation_divider__L2VDY","mobileContent":"MobileNavigation_mobileContent__V8ufn"};